export default __webpack_public_path__ + "static/C2-a7304944e76b6f16f8c0126f6aaca18e.png";